<div class="dropdown" (click)="toggle()">{{dropdownText}} <i class="fa fa-angle-down"></i></div>
<div class="popup" *ngIf="opened" [@slideUpDown]="opened">
    <div class="menu-item" *ngFor="let i of items">
        <a *ngIf="i.route" [routerLink]="i.route" (click)="close()">{{i.text}}</a>
        <a *ngIf="!i.route" href="#" (click)="invokeItemClick(i, $event)">{{i.text}}</a>
    </div>
</div>